import React, { memo, useEffect, useState } from 'react'
import { Carousel } from "react-responsive-carousel";
import { nanoid } from "nanoid";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { api, baseURL, customerReqConfig } from "../../src/include/api";


const BigDealOne = () => {

            const [fetchLoading, setFetchLoading] = useState(false);
            const [slideList, setSlideList] = useState([]);
        
            const getSlides = () => {
                setFetchLoading(true);
                api.get('/slide_show/', customerReqConfig).then(response => {
                    if (response.status === 200) {
                        setSlideList(response.data.data);
                    }
                }).catch(error => {
                    console.error("Error fetching slides", error);
                }).finally(() => {
                    setFetchLoading(false);
                });
            };
        
            useEffect(() => {
                getSlides();
            }, []);
        
            // Filter slides for each container
            const BigdealoneSlides = slideList?.filter(slide => slide.status === 'active' && slide.type === 'big deals slide');
    
    return (
        <div className="big-deal rounded-16 overflow-hidden flex-between position-relative py-20">
            <div className="container container-lg">
                <div className="big-deal-box position-relative z-1 rounded-16 py-40 overflow-hidden">
                    
                        {fetchLoading ? (
                            <div className="w-100 bg-light" style={{ height: '300px' }} />
                        ) : (
                            <Carousel
                                autoPlay
                                infiniteLoop
                                interval={3000}
                                preventMovementUntilSwipeScrollTolerance
                                showThumbs={false}
                                transitionTime={100}
                                showStatus={false}
                                showIndicators={false} // Hides bottom dots

                            >
                                {BigdealoneSlides?.map(slide => (
                                    <CarouselItem slide={slide} key={nanoid()} />
                                ))}
                            </Carousel>
                        )}      
                </div>
            </div>
        </div>
    )
}

const CarouselItem = ({ slide }) => {
    const handleClick = () => {
        if (slide.linkUrl) {
            window.open(slide.linkUrl);
        }
    }
    return (
        <div className="mx-2" style={{ height: '100%', flex: '1 1 0',cursor:"pointer" }} onClick={handleClick}>
            <img
                className="fit-cover w-100 h-100"
                src={slide.imageUrl ? `${baseURL}/${slide.imageUrl}` : ""}
                alt=""
            />
        </div>
    );
};


export default BigDealOne